/**
 * Servicio para gestionar AI Assistant (chatbot)
 * Endpoints específicos bajo /assistant
 */
import { AssistantDetail, DeleteDocumentResponse, GenerateSecretKeyResponse, ListDocumentsResponse, SupportAskResponse, UploadRequestResponse, WidgetConfigUpdate } from '../types/chatbot.type';
import { apiService } from './api';



export class AssistantService {
  private baseEndpoint = '/assistant';

  async getDetail(serviceId: string): Promise<AssistantDetail> {
    return apiService.get<AssistantDetail>(`${this.baseEndpoint}/detail/${serviceId}`);
  }

  async generateSecretKey(apiKey: string, tenantId: string): Promise<GenerateSecretKeyResponse> {
    return apiService.post<GenerateSecretKeyResponse>(`${this.baseEndpoint}/generate-secret`, {
      apiKey,
      tenantId,
    });
  }

  async requestUpload(serviceId: string, filename: string, fileSize: number): Promise<UploadRequestResponse> {
    return apiService.post<UploadRequestResponse>(`${this.baseEndpoint}/upload`, {
      serviceId,
      filename,
      fileSize,
    });
  }

  async updateWidgetConfig(apiKey: string, tenantId: string, config: WidgetConfigUpdate): Promise<{ message: string; template: WidgetConfigUpdate; allowedOrigins?: string[] }> {
    return apiService.put<{ message: string; template: WidgetConfigUpdate; allowedOrigins?: string[] }>(`${this.baseEndpoint}/widget-config`, {
      apiKey,
      tenantId,
      config,
    });
  }

  async listDocuments(serviceId: string): Promise<ListDocumentsResponse> {
    return apiService.get<ListDocumentsResponse>(`${this.baseEndpoint}/documents/${serviceId}`);
  }

  async deleteDocument(serviceId: string, filename: string): Promise<DeleteDocumentResponse> {
    return apiService.delete<DeleteDocumentResponse>(
      `${this.baseEndpoint}/documents/${serviceId}/${encodeURIComponent(filename)}`
    );
  }

  async supportAsk(message: string, language: string = 'es'): Promise<SupportAskResponse> {
    return apiService.post<SupportAskResponse>(`${this.baseEndpoint}/support-ask`, {
      message,
      language
    });
  }
}

export const assistantService = new AssistantService();